import * as React from "react";

/**
 * Viewport width below which components treat themselves as "mobile".
 *
 * Exported because layout containers have to agree with it: `MainPageWrapper`
 * only switches its sidebar row on at Tailwind's `md` (768px) because rails
 * key their desktop styling off `useIsMobile()`. Pinned by
 * `MainPageWrapper.test.tsx`.
 */
export const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
